import { render, staticRenderFns } from "./CmgToast.vue?vue&type=template&id=0aaca3b6&scoped=true&lang=pug&"
import script from "./cmg-toast.ts?vue&type=script&lang=ts&"
export * from "./cmg-toast.ts?vue&type=script&lang=ts&"
import style0 from "./CmgToast.vue?vue&type=style&index=0&id=0aaca3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaca3b6",
  null
  
)

export default component.exports